import { render, staticRenderFns } from "./ManagerStudioPicker.vue?vue&type=template&id=8f012246&scoped=true&"
import script from "./ManagerStudioPicker.vue?vue&type=script&lang=js&"
export * from "./ManagerStudioPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f012246",
  null
  
)

export default component.exports